class InspirationDetailTileController {
    constructor($scope, $element, $state, moveFocus, inspirationService) {
        this.$scope = $scope;
        this.$element = $element;
        this.$state = $state;
        this.moveFocus = moveFocus;
        this.inspirationService = inspirationService;
    }

    $onInit() {
        this.$scope.$on('window:resize', () => {
            if (this.isDetailExpanded()) {
                this.expand();
            }
        });

        this.$scope.$watch(
            () => this.$state.params.cardId,
            cardId => (this.card.ID === cardId ? this.expand() : this.shrink()),
        );
    }

    openCardDetail() {
        this.$state.go('.', { cardId: this.card.ID, name: this.card.UrlPart });
    }

    closeCardDetail() {
        this.$state.go('.', { cardId: undefined, name: undefined });
    }

    isDetailExpanded() {
        return this.card.ID === this.$state.params.cardId;
    }

    shrink() {
        this.$element.find('._inspirationDetailTile').css('margin-bottom', '');
    }

    expand() {
        const $tile = this.$element.find('._inspirationDetailTile');
        const $detail = this.$element.find('._inspirationDetailTile-detail');

        $tile.css('margin-bottom', $detail.height() + 20);

        $detail.css('top', $tile.position().top + $tile.height());
    }

    goToCard($event) {
        if (this.card.CardLinkTarget || this.card.ProductGroupId || this.card.Product || this.card.RecipeId) {
            this.inspirationService.setContentCardId(this.card.ID);
        } else if ($event.button === 0) {
            $event.preventDefault();
            this.openCardDetail();
            this.moveFocus('._inspirationDetailTile-detail');
        }
    }
}

InspirationDetailTileController.$inject = ['$scope', '$element', '$state', 'MoveFocus', 'InspirationService'];

const inspirationDetailTileComponentDefinition = {
    bindings: {
        card: '<',
    },
    controller: InspirationDetailTileController,
    template: require('./inspiration-detail-tile.component.html').trim(),
};

module.exports = {
    InspirationDetailTileController,
    inspirationDetailTileComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/inspiration/tile/inspiration-detail-tile.component.js